import router from '../router/index'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import * as config from '../core/config'

NProgress.configure({ ease: 'ease', speed: 500, showSpinner: false })

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (config.getAccessToken() == null) {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // next(`/login?redirect=${to.path}`)
      next('/login')
    }
  } else {
    next()
  }
})
router.afterEach(() => {
  NProgress.done()
})
